/*
  lb-basis.js: gemeinsames Skript aller Lenabo-Abschnitte, Stand 03.11.2026
  Geladen von snippets/lb-basis (defer). Jeder Lenabo-Abschnitt bindet das Snippet ein, das Skript
  läuft trotzdem nur einmal (window.__lbBasis).

  Enthält: Tracking (dataLayer und Shopify Customer Events), Hörproben (data-lb-audio), Klick-Events
  (data-lb-event, data-lb-pick), Hinweise mit Ablaufdatum (data-lb-until), Vergleichstabelle (Verlaufsschatten),
  Erklärvideo im Overlay (data-lb-video-open), Erklärung „Warum KI-Bilder?“ (#lb-ki-info) und sanftes Einblenden.
  Nur für die Produktseite (Warenkorb-Leiste, KI-Etikett in der Galerie): assets/lb-kaufbox.js.

  Tracking-Events (alle mit Präfix lb_): lb_hoerprobe_play (lb_title, lb_lenabie), lb_lenabie_wechsel (lb_from, lb_to),
  lb_figur_klick (lb_lenabie), lb_erklaervideo_start, lb_erklaervideo_ende, lb_ki_hinweis, lb_hinweis_button,
  lb_weihnachten_button, lb_hero_button. GTM leitet sie erst weiter, wenn dort ein Trigger auf ^lb_ angelegt ist.
*/
(function () {
  if (window.__lbBasis) return;
  window.__lbBasis = true;

  function track(name, data) {
    data = data || {};
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, data));
    } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) {}
  }
  window.lbTrack = track;

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  // Hörproben: ein Player für die ganze Seite, ein zweiter Klick stoppt
  var audio = null;
  var activeBtn = null;
  function stop() {
    if (audio) {
      try { audio.pause(); audio.currentTime = 0; } catch (e) {}
    }
    if (activeBtn) {
      activeBtn.classList.remove('is-playing');
      activeBtn.setAttribute('aria-pressed', 'false');
    }
    audio = null;
    activeBtn = null;
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var btn = e.target.closest('[data-lb-audio]');
    if (btn) {
      e.preventDefault();
      if (btn === activeBtn) { stop(); return; }
      stop();
      var a = new Audio(btn.getAttribute('data-lb-audio'));
      audio = a;
      activeBtn = btn;
      btn.classList.add('is-playing');
      btn.setAttribute('aria-pressed', 'true');
      a.addEventListener('ended', function () { if (audio === a) stop(); });
      var p = a.play();
      if (p && typeof p.catch === 'function') p.catch(function () { if (audio === a) stop(); });
      track('lb_hoerprobe_play', {
        lb_title: btn.getAttribute('data-lb-title') || '',
        lb_lenabie: btn.getAttribute('data-lb-lenabie') || ''
      });
      return;
    }

    var ev = e.target.closest('[data-lb-event]');
    if (ev) {
      var evData = {};
      if (ev.hasAttribute('data-lb-lenabie')) evData.lb_lenabie = ev.getAttribute('data-lb-lenabie');
      track(ev.getAttribute('data-lb-event'), evData);
    }

    var pick = e.target.closest('[data-lb-pick]');
    if (pick) {
      track('lb_lenabie_wechsel', {
        lb_from: pick.getAttribute('data-lb-from') || '',
        lb_to: pick.getAttribute('data-lb-pick') || ''
      });
    }
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop();
  });

  // Hinweise mit Ablaufdatum (data-lb-until="JJJJ-MM-TT") auch aus dem Seiten-Cache entfernen
  onReady(function () {
    var now = new Date();
    document.querySelectorAll('[data-lb-until]').forEach(function (el) {
      var until = new Date(el.getAttribute('data-lb-until') + 'T23:59:59');
      if (!isNaN(until.getTime()) && now > until) el.remove();
    });
  });

  // Vergleichstabelle: Klassen für die Verlaufsschatten (is-scroll, is-start, is-end)
  function compareState(el) {
    var max = el.scrollWidth - el.clientWidth;
    el.classList.toggle('is-scroll', max > 2);
    el.classList.toggle('is-start', el.scrollLeft <= 2);
    el.classList.toggle('is-end', el.scrollLeft >= max - 2);
  }
  function initCompare() {
    document.querySelectorAll('.lb-band-compare').forEach(function (el) {
      compareState(el);
      if (el.__lbCompare) return;
      el.__lbCompare = true;
      el.addEventListener('scroll', function () { compareState(el); }, { passive: true });
    });
  }
  onReady(initCompare);
  window.addEventListener('resize', function () { document.querySelectorAll('.lb-band-compare').forEach(compareState); });
  document.addEventListener('shopify:section:load', initCompare);

  // Erklärvideo: Overlay (dialog) öffnen, Video erst jetzt aus dem template einsetzen und mit Ton starten
  function videoClosed(dlg) {
    var v = dlg.querySelector('video');
    if (v) { try { v.pause(); } catch (e) {} }
    document.documentElement.classList.remove('lb-video-offen');
  }
  function openVideo(dlg) {
    if (!dlg) return;
    var frame = dlg.querySelector('[data-lb-video-frame]');
    var video = frame && frame.querySelector('video');
    if (frame && !video) {
      var tpl = dlg.querySelector('template[data-lb-video-tpl]');
      if (tpl) frame.appendChild(tpl.content.cloneNode(true));
      video = frame.querySelector('video');
      if (video) {
        video.setAttribute('playsinline', '');
        video.playsInline = true;
        video.controls = true;
        video.addEventListener('ended', function () { track('lb_erklaervideo_ende', {}); });
      }
    }
    if (!dlg.__lbVideo) {
      dlg.__lbVideo = true;
      dlg.addEventListener('close', function () { videoClosed(dlg); });
    }
    if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); }
    else dlg.setAttribute('open', '');
    document.documentElement.classList.add('lb-video-offen');
    if (video) {
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }
    track('lb_erklaervideo_start', {});
  }
  function closeVideo(dlg) {
    if (!dlg) return;
    if (typeof dlg.close === 'function' && dlg.open) dlg.close();
    else { dlg.removeAttribute('open'); videoClosed(dlg); }
  }
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var opener = e.target.closest('[data-lb-video-open]');
    if (opener) { e.preventDefault(); openVideo(document.getElementById(opener.getAttribute('data-lb-video-open'))); return; }
    var closer = e.target.closest('[data-lb-video-close]');
    if (closer) { closeVideo(closer.closest('.lb-video')); return; }
    if (e.target.classList && e.target.classList.contains('lb-video')) closeVideo(e.target);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var dlg = document.querySelector('.lb-video[open]');
    if (dlg && typeof dlg.showModal !== 'function') closeVideo(dlg);
  });

  // Erklärung „Warum KI-Bilder?“: einmal je Seite aus der Vorlage in snippets/lb-basis anlegen
  function kiInfo() {
    if (document.getElementById('lb-ki-info')) return;
    var tpl = document.querySelector('template[data-lb-ki-info-tpl]');
    if (tpl) document.body.appendChild(tpl.content.cloneNode(true));
  }
  onReady(kiInfo);
  document.addEventListener('shopify:section:load', kiInfo);
  // Browser ohne Popover-Funktion: Erklärung per Klasse zeigen und schließen
  if (!HTMLElement.prototype.hasOwnProperty('popover')) {
    document.addEventListener('click', function (e) {
      var info = document.getElementById('lb-ki-info');
      if (!info || !e.target || !e.target.closest) return;
      var t = e.target.closest('[popovertarget="lb-ki-info"]');
      if (t) {
        e.preventDefault();
        info.classList.toggle('is-open', t.getAttribute('popovertargetaction') !== 'hide' && !info.classList.contains('is-open'));
      } else if (info.classList.contains('is-open') && !e.target.closest('#lb-ki-info')) {
        info.classList.remove('is-open');
      }
    });
    document.addEventListener('keydown', function (e) {
      var info = document.getElementById('lb-ki-info');
      if (e.key === 'Escape' && info) info.classList.remove('is-open');
    });
  }

  // Sanft einblenden: Die Klasse lb-einblenden setzt snippets/lb-basis schon beim Laden (nur ohne
  // „Bewegung reduzieren“, mit IntersectionObserver und außerhalb des Theme-Editors). Hier werden die
  // Elemente beim ersten Scrollen sichtbar, je Element einmal und leicht gestaffelt.
  onReady(function () {
    var html = document.documentElement;
    if (!html.classList.contains('lb-einblenden') || !('IntersectionObserver' in window)) return;
    // EINSTELLUNG: Wie weit ein Element im Bild sein muss, bevor es einblendet,
    // in Prozent der Fensterhöhe, von unten gemessen. Größere Zahl = später.
    var SPAETER_HANDY = 22;    // Handy bis 767 px Breite
    var SPAETER_DESKTOP = 6;   // größere Bildschirme
    var handy = window.matchMedia('(max-width: 767px)').matches;
    var sel = ['.lb-band__head', '.lb-band-items>li', '.lb-band-compare', '.lb-band__media', '.lb-band-note', '.lb-band-logos__item', '.lb-band-titles', '.lb-band__cta', '.lb-band__video', '.lb-band-trusted', '.lb-band-gpsr']
      .map(function (s) { return '.lb-band:not(.lb-band--still) ' + s; }).join(',');
    var els = document.querySelectorAll(sel);
    var io = new IntersectionObserver(function (entries) {
      var neu = entries.filter(function (en) { return en.isIntersecting; }).map(function (en) { return en.target; });
      neu.sort(function (a, b) {
        var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
        return (ra.top - rb.top) || (ra.left - rb.left);
      });
      neu.forEach(function (el, i) {
        el.style.setProperty('--lb-d', Math.min(i, 5) * 90 + 'ms');
        el.classList.add('is-da');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -' + (handy ? SPAETER_HANDY : SPAETER_DESKTOP) + '% 0px', threshold: handy ? 0 : 0.08 });
    els.forEach(function (el) { io.observe(el); });
    // Klangwelle: zeichnet sich beim ersten Sichtkontakt von links nach rechts (CSS: .lb-welle.is-gezeichnet),
    // auch im Hero und in der Figurenwahl, die selbst nicht einblenden
    var ioW = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-gezeichnet');
        ioW.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -' + (handy ? SPAETER_HANDY : SPAETER_DESKTOP) + '% 0px', threshold: 1 });
    document.querySelectorAll('.lb-welle').forEach(function (el) { ioW.observe(el); });
    window.__lbEinblendenBereit = true;
  });
})();
